import type { XingletInterface } from './xinglet-helpers';
import { XingletWrapper } from './xinglet-helpers';

export type FormProps = {
  onSectionVisibilityChange: (
    section: string,
    intersectionRatio: number
  ) => void;
};

export type FormXinglet = XingletInterface<FormProps>;

export const Form = XingletWrapper<FormProps>(
  '@xing-com/crate-lebenslauf-components-form'
);
